// extracted by mini-css-extract-plugin
export default {"applicationContainer":"AuthorizedLayout_applicationContainer__rpfaf"};